export const CLASS_CONSTANTS = {
  BUTTON_CANCEL: 'CANCEL',
  BUTTON_SUBMIT: 'CREATE CLASS',
  COURSE_INSTANCE_LABEL: 'Class Name',
  COURSE_INSTANCE_PLACEHOLDER: 'Enter a class name',
  CREATE_HEADER: 'Create Class',
  SCHOOL_LABEL: 'School',
  SCHOOL_PLACEHOLDER: 'Select a school',
  SELECTED_COURSE_LABEL: 'Grade',
  SELECTED_COURSE_PLACEHOLDER: 'Select a grade',
  NO_GRADES_ENABLED_MESSAGE:
    'No grades are enabled for this school. Select a different school or contact your administrator.',
  ASK_NO_TEACHING: 'Not teaching students?',
  PREVIEW_LESSONS: 'Preview lessons',
  ALMOST_THERE: 'Almost there!',
  START_TEACHING: ' Name your class to start teaching.',
  COMPONENT_TYPE_COURSE: 'course',
}

export const SMALL_GROUP_CONSTANTS = {
  BUTTON_CANCEL: 'Cancel',
  BUTTON_SUBMIT: 'Create Small Group',
  COURSE_INSTANCE_LABEL: 'Small Group Name',
  COURSE_INSTANCE_PLACEHOLDER: 'Enter a small group name',
  CREATE_HEADER: 'Create Small Group',
  SCHOOL_LABEL: 'School',
  SCHOOL_PLACEHOLDER: 'Select a school',
  SELECTED_COURSE_LABEL: 'Grade Band',
  SELECTED_COURSE_PLACEHOLDER: 'Select a grade band',
  NO_GRADES_ENABLED_MESSAGE:
    'No grade bands are enabled for this school. Select a different school or contact your administrator.',
  ASK_NO_TEACHING: 'Not teaching students?',
  PREVIEW_LESSONS: 'Preview lessons',
  ALMOST_THERE: 'Almost there!',
  START_TEACHING:
    ' Name your small group to start teaching tiered interventions.',
  COMPONENT_TYPE_SMALL_GROUP: 'smallGroup',
  TIER_LABEL_TEXT: 'TIER 2',
}

export function getCreateConstants(componentType) {
  if (componentType === 'smallGroup') return SMALL_GROUP_CONSTANTS
  return CLASS_CONSTANTS
}
